module.exports = __webpack_public_path__ + "media/src/images/top_covers/com_autumn_03-907d203c6e1da847a781ea1c5b3b8569.png";